import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requiredPermission, role }) => {
  // ✅ Include 'loading' from context
  const { user, permissions, loading } = useAuth(); 
  const token = localStorage.getItem("token");

  // 1. Wait for AuthContext to finish loading from localStorage
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  // 2. Basic Security Check
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // 3. Admin & Super Admin Bypass (The Master Key)
  const userRole = user?.role?.toLowerCase() || '';
  if (userRole === "super admin" || userRole === "admin" || permissions.includes("ALL")) {
    return children;
  }

  // 4. Permission Check (The New Dynamic Way)
  // Uses the "cleaned" strings from your backend (e.g., 'project.view')
  if (requiredPermission) {
    if (permissions.includes(requiredPermission)) {
      return children;
    } else {
      console.warn(`⛔ Access Denied: Missing permission "${requiredPermission}"`);
      return <Navigate to="/admin/dashboard" replace />; // Redirect to dashboard instead of login
    }
  }

  // 5. Role Check (Legacy Support)
  if (role) {
    if (user.role === role) {
      return children;
    } else {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;